import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Collapse(props) {
  const { height, width, iconColor } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height}>
      <path
        fill={iconColor}
        d="M19.5,3.09L15,7.59V4H13V11H20V9H16.41L20.91,4.5L19.5,3.09M4,13V15H7.59L3.09,19.5L4.5,20.91L9,16.41V20H11V13H4Z"
      />
    </svg>
  );
}

Collapse.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Collapse.defaultProps = {
  height: undefined,
  width: 120,
  iconColor: colors.colorGrey02
};

export default Collapse;
